import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { StorageService } from '@src/app/modules/auth';
import { StorageKeys } from '@src/constants/storage';

import { ListModeType, ListModeSwitcherSize } from './types';

/**
 * Компонент переключения вида списка
 * @param {ListModeSwitcherSize} size - размер
 * @param {ListModeType} mode - Вид списка (по умолчанию list)
 * @param {boolean} useMapMode - Использовать mode = 'map' (по умолчанию true)
 */
@Component({
  selector: 'app-list-mode-switcher',
  templateUrl: './list-mode-switcher.component.html',
  styleUrls: ['./list-mode-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListModeSwitcherComponent implements OnInit {
  @Input() size: ListModeSwitcherSize = 'xs';

  @Input() storageKey?: StorageKeys;

  @Input() useMode: ListModeType[] = ['grid', 'list'];
  @Input() mode: ListModeType = 'list';
  @Output() modeChange = new EventEmitter<ListModeType>();

  private readonly storageService = inject(StorageService);

  ngOnInit(): void {
    if (this.storageKey) {
      const mode = this.storageService.getItem(this.storageKey) as ListModeType | null;

      if (mode) {
        this.mode = this.useMode.includes(mode) ? mode : this.useMode[0];
        this.modeChange.emit(this.mode);
      }
    }
  }

  onChangeMode(mode: ListModeType) {
    if (this.storageKey) {
      this.storageService.setItem(this.storageKey, mode);
    }

    this.mode = mode;
    this.modeChange.emit(mode);
  }
}
